import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Navb from "../../components/navbar/Navb";
import Footer from "../../components/footer/Footer";
import "./ourPP.css";
const PrivacyPolicy = () => {
  return (
    <>
      <Navb />
      <Container className="custom-page">
        <h1>Privacy Policy</h1>
        <p>Last updated: 19-05-2024</p>

        <section>
          <h2>Introduction</h2>
          <p>
            Udaya Solution ("we", "us", or "our") operates the
            [https://udayasoln.netlify.app] website (the "Service"). This page
            informs you of our policies regarding the collection, use, and
            disclosure of personal data when you use our Service and the choices
            you have associated with that data.
          </p>
        </section>

        <section>
          <h2>Information Collection and Use</h2>
          <p>
            We collect several types of information for various purposes to
            provide and improve our Service to you.
          </p>
          <h3>Types of Data Collected</h3>
          <ul style={{ maxHeight: "unset" }}>
            <li>
              <strong>Personal Data:</strong> While using our Service, we may
              ask you to provide us with certain personally identifiable
              information that can be used to contact or identify you ("Personal
              Data"). Personally identifiable information may include, but is
              not limited to:
              <ul style={{ maxHeight: "unset" }}>
                <Row className="custom-row">
                  <Col>
                    <li>Name</li>
                    <li>Phone Number</li>
                    <li>Email Address</li>
                    <li>Location</li>
                    <li>Years of Experience</li>
                  </Col>
                  <Col>
                    <li>Current Salary</li>
                    <li>Expected Salary</li>
                    <li>Skills</li>
                    <li>Current Position</li>
                    <li>Current Company</li>
                    <li>Resume</li>
                  </Col>
                </Row>
              </ul>
            </li>
          </ul>
        </section>

        <section>
          <h2>How We Collect Information</h2>
          <p>
            We collect information directly from candidates when they submit
            their details through our website.
          </p>
        </section>

        <section>
          <h2>Use of Data</h2>
          <p>Udaya Solution uses the collected data for various purposes:</p>
          <ul style={{ maxHeight: "unset" }}>
            <Row className="custom-row">
              <Col>
                <li>To provide and maintain our Service</li>
                <li>To notify you about changes to our Service</li>
                <li>
                  To allow you to participate in interactive features of our
                  Service when you choose to do so
                </li>
                <li>To provide customer support</li>
                <li>
                  To gather analysis or valuable information so that we can
                  improve our Service
                </li>
              </Col>
              <Col>
                {" "}
                <li>To monitor the usage of our Service</li>
                <li>To detect, prevent and address technical issues</li>
                <li>To fulfill any other purpose for which you provide it</li>
              </Col>
            </Row>
          </ul>
        </section>

        <section>
          <h2>Disclosure of Data</h2>
          <p>
            We may disclose personal information that we collect, or you
            provide:
          </p>

          <ul style={{ maxHeight: "unset" }}>
            <Row className="custom-row">
              <Col>
                <li>To our subsidiaries and affiliates</li>
                <li>
                  To contractors, service providers, and other third parties we
                  use to support our business
                </li>
              </Col>
              <Col>
                {" "}
                <li>To fulfill the purpose for which you provide it</li>
                <li>
                  For any other purpose disclosed by us when you provide the
                  information
                </li>
                <li>With your consent in any other cases</li>
              </Col>
            </Row>
          </ul>
        </section>
        <section>
          <h2>Security of Data</h2>
          <p>
            The security of your data is important to us, but remember that no
            method of transmission over the Internet or electronic storage is
            100% secure. While we strive to use commercially acceptable means to
            protect your Personal Data, we cannot guarantee its absolute
            security.
          </p>
        </section>

        <section>
          <h2>Changes to This Privacy Policy</h2>
          <p>
            We may update our Privacy Policy from time to time. We will notify
            you of any changes by posting the new Privacy Policy on this page.
          </p>
        </section>
        <section>
          <h2>Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact
            us via our <a href="/contact">Contact Us</a> page.
          </p>
        </section>
      </Container>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
